import type { AnonymousRecordUploadStatus } from './anonymous-record-upload-status';

export const EFAX_DISPLAY_STATUS_OPTIONS: Array<{
  value: AnonymousRecordUploadStatus;
  label: string;
}> = [
  { value: 'identifying', label: 'Identifying' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'error', label: 'Error' },
];

export const isEfaxIdentifying = (status: AnonymousRecordUploadStatus) =>
  status === 'identifying';

export const isEfaxProcessing = (status: AnonymousRecordUploadStatus) =>
  status === 'processing';

export const isEfaxCompleted = (status: AnonymousRecordUploadStatus) =>
  status === 'completed';

export const isEfaxError = (status: AnonymousRecordUploadStatus) =>
  status === 'error';

export const isEfaxProcessingOrCompleted = (
  status: AnonymousRecordUploadStatus,
) => isEfaxProcessing(status) || isEfaxCompleted(status);
